const ROUTES = {
  "/": {
    "name": "HomePage09ac3914Bb1b4ab08f7a0af507c4211d",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageD5342540Ccf5469aBebcFa53ef18815f",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages91249ff3B23043049471A26354174682",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage6ffca564A0a44356B331Ada13f7a9cc1",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage7ef85935983a482289d43603fc712fda",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;